import { baseLocale, locales, type Locale } from '$lib/paraglide/runtime';

/**
 * Path helpers dla wiki. Trzymane osobno od content.ts (globów Vite): importuje
 * je root `+layout.server.ts`, który nie może ciągnąć za sobą indeksu contentu.
 */
const WIKI_SEGMENT = 'wiki';

/**
 * True dla ścieżek wiki, z prefiksem locale lub bez (`/wiki/...` i
 * `/pl/wiki/...`). Wzorzec jak `isAppAreaPath` w `$lib/i18n/app-locale.ts`.
 */
export function isWikiPath(pathname: string): boolean {
	const segments = pathname.split('/').filter(Boolean);
	const head = (locales as readonly string[]).includes(segments[0] ?? '')
		? segments[1]
		: segments[0];
	return head === WIKI_SEGMENT;
}

/**
 * Locale wyprowadzone z pathname (deterministyczne na serwerze, przy
 * prerenderze i na kliencie — w odróżnieniu od `getLocale()`). `event.url`
 * zachowuje oryginalną formę `/pl/...`; reroute wpływa tylko na matching tras.
 */
export function wikiLocaleFromPathname(pathname: string): Locale {
	const first = pathname.split('/').filter(Boolean)[0] ?? '';
	return (locales as readonly string[]).includes(first) ? (first as Locale) : baseLocale;
}
